import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Download from '@material-ui/icons/CloudDownload';
import { showNotification, GET_ONE, GET_LIST, LinearProgress } from 'react-admin';
import { push } from 'connected-react-router';
import sanitize from 'sanitize-filename'

class DownloadFileButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: props.record,
    }
  }
  render() {
    const { file } = this.state;
    return (
      <Fragment style={{padding: '1em'}}>
        <a href={file.download_url } target="_blank" style={{textDecoration: 'none', color: 'inherit'}}>
          <Button color="primary">
            <Download />
          </Button>
        </a>
      </Fragment>
    );
  }
}

export default connect(null, { })(DownloadFileButton);
